export const mira_boz_01_puppies = [
    {title:"Puppies", url:"litters/previous/mira_boz_2023/puppies"},
];